import { CDateRangePicker } from './CDateRangePicker.js';

const CDateRangePickerPlugin = {
    install: (app) => {
        app.component(CDateRangePicker.name, CDateRangePicker);
    },
};

export { CDateRangePicker, CDateRangePickerPlugin };
//# sourceMappingURL=index.js.map
